class ShallowClone extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  switchDuration(turnOff) {
    if (turnOff) {
      this.classList.add('duration-0');
      this.classList.remove('duration-300');
    } else {
      this.classList.remove('duration-0');
      this.classList.add('duration-300');
    }
  }
  connectedCallback() {
    let lastScroll = document.documentElement.scrollTop;
    window.addEventListener('scroll', () => {
      if (this.paused || window.innerWidth > 767) return;
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.pauseScroll();
        this.switchDuration(true);
        requestAnimationFrame(() => {
          this.classList.add('-translate-y-full');
          setTimeout(() => {
            this.switchDuration(false);
          }, 500);
        });
      } else if (scrollTop < lastScroll) {
        this.classList.remove('-translate-y-full');
      } else {
        this.classList.add('-translate-y-full');
      }
      lastScroll = scrollTop;
    });
    this.querySelectorAll('[data-proxy-click]').forEach((el) => {
      el.addEventListener('click', (ev) => {
        ev.preventDefault();
        const targetNode = document.querySelector(el.dataset.proxyClick);
        if (targetNode) {
          targetNode.click();
        }
      });
    });
  }

  pauseScroll() {
    this.paused = true;
    setTimeout(() => {
      this.paused = false;
    }, 250);
  }
}

customElements.define('shallow-clone', ShallowClone);
